module.exports = __webpack_public_path__ + "static/img/1_8_2.4e97a47f.jpg";